




import Vue from "vue";
import Component from "vue-class-component";

@Component({
  props: {
    graphData: Array
  }
})
export default class WeatherGraph extends Vue {
  private graphData: any;
  private seriesData = [];
  private seriesDataMax = [];
  private seriesDataMin = [];

  private chartOptions = {
    title: {
      text: ""
    },
    
    chart: {
      type: 'area'
    },
    subtitle: {
      text: ""
    },

    tooltip: {
      formatter: function() {
        const time = new Date((this as any).x * 1000);
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ];
        let minutes = time.getMinutes();
        let hour = time.getHours();
        let date = time.getDate();
        let month = time.getMonth();
        let minutesString = '';
        let hourString = '';
        if (minutes < 10) {
          minutesString = "0" + minutes.toString();
        }
        if (hour < 10) {
          hourString = "0" + hour.toString();
        }
        return (
          "The temperature on <b>" +
          date +
          "  " +
          monthNames[month] +
          "  " +
          hourString +
          ":" +
          minutesString +
          "</b> is <b>" +
          Math.round((this as any).y - 273.15) +
          "˚" +
          "</b>"
        );
      }
    },
    yAxis: {
      title: {
        text: "Temperature (Celsius)"
      },
      max: 55+273.15,
      min: -20 + 273.15,
      labels: {
        formatter: function() {
          return Math.round((this as any).value - 273.15) + "˚";
        }
      }
    },
    xAxis: {
      title: {
        text: "Time"
      },
      labels: {
        formatter: function() {
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ];
          const time = new Date((this as any).value * 1000);
          let minutes = time.getMinutes();
          let hour = time.getHours();
          let date = time.getDate();
          let month = time.getMonth();
          let minutesString = '';
          let hourString = '';
          if (minutes < 10) {
            minutesString = "0" + minutes.toString();
          } else {
            minutesString = minutes.toString();
          }
          if (hour < 10) {
            hourString = "0" + hour.toString();
          } else {
            hourString = hour.toString();
          }
          return date + "  " + monthNames[month] + "  " + hourString + ":" + minutesString;
        }
      }
    },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "middle"
    },

    plotOptions: {
      series: {
        label: {
          connectorAllowed: false
        }
      }
    },

    series: [
      {
        name: "Temperature",
        data: this.seriesData,
        color: {
          linearGradient: {x1:0, x2:0, y1:0, y2: 1},
          stops: [
            [0, '#152a47'],//start
            // [0.5, '#3E5067'], //middle
            [1, '#98a3b3'], //end
          ]
        }
      },
    ],

    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom"
            }
          }
        }
      ]
    }
  };

  mounted() {
    for (let i = this.graphData.length - 1; i >= 0; i--) {
      this.seriesData.push([
        this.graphData[i].dt,
        this.graphData[i].main.temp
      ] as never);
      this.seriesDataMax.push([
        this.graphData[i].dt,
        this.graphData[i].main.temp_max
      ] as never);
      this.seriesDataMin.push([
        this.graphData[i].dt,
        this.graphData[i].main.temp_min
      ] as never);
    }
  }

  updated() {
  }
}
